import { useState } from 'react';

export function AttestationForm({ onAccept }: { onAccept: (statement: string) => void }) {
  const [statement, setStatement] = useState('');
  return (
    <form onSubmit={(event) => { event.preventDefault(); if (statement.length > 0) onAccept(statement); }} className="flex flex-col gap-2">
      <label htmlFor="attestation-statement" className="text-sm font-semibold">Statement</label>
      <textarea id="attestation-statement" value={statement} onChange={(event) => setStatement(event.target.value)} rows={3} className="rounded-md border border-input px-3 py-2" />
      <button type="submit" disabled={statement.length === 0} className="min-h-11 rounded-md bg-foreground px-4 text-sm font-semibold text-background">Record attestation</button>
    </form>
  );
}

